import { Dispatch } from "redux";
import DashboardAnalyticService from "service/DashboardAnalytic";
import { showMessage } from "utilities/helper";

export const getTotalMembers = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalMembers();

    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_MEMBER", value: data.total_members });
    dispatch({ type: "SET_INCREASE_MEMBER", value: data.increase_member });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrsClaimed = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_OCR_CLAIMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalOcrsClaimed();

    dispatch({ type: "SET_TOTAL_OCR_CLAIMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_OCR_CLAIMED", value: data.total_ocrs });
    dispatch({ type: "SET_TOTAL_AMOUNT", value: data.total_amount });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_OCR_CLAIMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalRewardsRedeemed = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalRewardsRedeemed();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED", value: data.total_rewards });
    dispatch({
      type: "SET_TOTAL_POINT_USED",
      value: data.total_point_used,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getMembershipsLevel = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getMembershipsLevel();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_TIER_CHART", value: data.tiers });
    dispatch({
      type: "SET_TIER_TOTAL_MEMBER",
      value: data.total_members_per_tier,
    });
    dispatch({
      type: "SET_TIER_BACKGROUND_CHART",
      value: data.tiers_background_color,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalMilkPoint = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalMilkPoint();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_EXP_POINT", value: data.total_exp_point });
    dispatch({ type: "SET_TOTAL_ULTRA_POINT", value: data.total_ultra_point });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getMembersGrowth = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getMembersGrowth();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({
      type: "SET_NEW_MEMBER_PER_MONTH",
      value: data.new_members_per_month,
    });
    dispatch({
      type: "SET_TOTAL_MEMBER_PER_MONTH",
      value: data.total_members_per_month,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalPortalMembers = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalPortalMembers();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_TENANT_PORTAL", value: data.tenant_portals });
    dispatch({
      type: "SET_TOTAL_PORTAL_MEMBER",
      value: data.total_portal_members,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_PORTAL_MEMBER", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getMembersGrowthPerPortal = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getMembersGrowthPerPortal();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({
      type: "SET_TOTAL_MEMBER_GROWTH_PER_PORTAL",
      value: data.total_members_growth_per_portal,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalMembersByProvince = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalMembersByProvince();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_PROVINCES", value: data.provinces });
    dispatch({ type: "SET_TOTAL_MEMBER_BY_PROVINCE", value: data.total });
    dispatch({
      type: "SET_TOTAL_TIER_MEMBER_BY_PROVINCE",
      value: data.total_member_tier,
    });
    dispatch({
      type: "SET_TOTAL_TIER_SILVER_BY_PROVINCE",
      value: data.total_silver_tier,
    });
    dispatch({
      type: "SET_TOTAL_TIER_GOLD_BY_PROVINCE",
      value: data.total_gold_tier,
    });
    dispatch({
      type: "SET_TOTAL_TIER_PLATINUM_BY_PROVINCE",
      value: data.total_platinum_tier,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalMembersVerifiedNumber =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
    try {
      const data =
        await DashboardAnalyticService.getTotalMembersVerifiedNumber();

      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      dispatch({ type: "SET_TOTAL_MEMBER_REGISTERED", value: data.registered });
      dispatch({
        type: "SET_TOTAL_MEMBER_VERIFIED_NUMBER",
        value: data.verified_member,
      });
    } catch (err: any) {
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getTotalMembersNftClaimed = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalMembersNftClaimed();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_NFT_CLAIMED", value: data.nft_claimed });
    dispatch({
      type: "SET_TOTAL_MEMBER_NFT_NOT_CLAIMED",
      value: data.nft_not_claimed,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getMembershipLeaderboard = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getMembershipLeaderboard();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({
      type: "SET_MEMBERSHIP_LEADERBOARD",
      value: data.membership_leaderboards,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalMembersRaffle = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_MEMBER_RAFFLE_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalMembersRaffle();

    dispatch({ type: "SET_TOTAL_MEMBER_RAFFLE_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_MEMBER_RAFFLE", value: data.total_members });
    dispatch({
      type: "SET_INCREASE_MEMBER_RAFFLE",
      value: data.increase_member,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_MEMBER_RAFFLE_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrRafflesClaimed = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_OCR_RAFFLE_CLAIMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalOcrRafflesClaimed();

    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_CLAIMED_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_CLAIMED", value: data.total_ocrs });
    dispatch({ type: "SET_TOTAL_CITY", value: data.total_cities });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_CLAIMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotlOcrRafflesAmount = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_OCR_RAFFLE_AMOUNT_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotlOcrRafflesAmount();

    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_AMOUNT_LOADING", value: false });
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_AMOUNT", value: data.total_amount });
    dispatch({
      type: "SET_TOTAL_INCREASE_OCR_RAFFLE_AMOUNT",
      value: data.increase_receipt_amount,
    });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE_AMOUNT_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrRafflesByCity = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalOcrRafflesByCity();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_RAFFLE_CITY", value: data.cities });
    dispatch({ type: "SET_TOTAL_OCR_RAFFLE", value: data.total });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrRafflesAmountByCity =
  () => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
    try {
      const data =
        await DashboardAnalyticService.getTotalOcrRafflesAmountByCity();

      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      dispatch({ type: "SET_RAFFLE_CITY", value: data.cities });
      dispatch({ type: "SET_TOTAL_OCR_RAFFLES_AMOUNT", value: data.total });
    } catch (err: any) {
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getTotalRafflesByCity = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalRafflesByCity();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_RAFFLE_CITY", value: data.cities });
    dispatch({ type: "SET_TOTAL_RAFFLE", value: data.total });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalRaffleWinnersByCity = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
  try {
    const data = await DashboardAnalyticService.getTotalRaffleWinnersByCity();

    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    dispatch({ type: "SET_RAFFLE_CITY", value: data.cities });
    dispatch({ type: "SET_TOTAL_RAFFLE_WINNER", value: data.total });
  } catch (err: any) {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const getTotalOcrRafflesByMerchant =
  (filterCity: string = "") =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
    try {
      const data = await DashboardAnalyticService.getTotalOcrRafflesByMerchant(
        filterCity
      );

      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      dispatch({ type: "SET_RAFFLE_MERCHANT_FOR_OCR_CLAIMED", value: data.merchants });
      dispatch({ type: "SET_TOTAL_OCR_RAFFLE_BY_MERCHANT", value: data.total });
    } catch (err: any) {
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getTotalOcrRafflesAmountByMerchant =
  (filterCity: string = "") =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
    try {
      const data =
        await DashboardAnalyticService.getTotalOcrRafflesAmountByMerchant(
          filterCity
        );

      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      dispatch({ type: "SET_RAFFLE_MERCHANT_FOR_OCR_AMOUNT", value: data.merchants });
      dispatch({
        type: "SET_TOTAL_OCR_RAFFLES_AMOUNT_BY_MERCHANT",
        value: data.total,
      });
    } catch (err: any) {
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

  export const getTotalOcrRafflesByUser = () => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: true });
    try {
      const data = await DashboardAnalyticService.getTotalOcrRafflesByUser();
  
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      dispatch({ type: "SET_RAFFLE_CITY", value: data.cities });
      dispatch({ type: "SET_TOTAL_OCR_RAFFLE_BY_USER", value: data.total });
    } catch (err: any) {
      dispatch({ type: "SET_TOTAL_REWARD_REDEEMED_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
